export default __webpack_public_path__ + "static/media/awl.872745d4.jpg";